
import { Component, Vue } from "vue-property-decorator";
import { schoolService } from "@/api/multi-tenancy/tenant";
import FormBase from "@/lib/view-base/formbase";
import { UpdateTenantDto } from "@/api/service-proxies";

@Component({
  name: "UpdateTenant",
  components: {}
})
export default class UpdateTenant extends FormBase {
  tenant: UpdateTenantDto = new UpdateTenantDto();

  rules: object = {
    tenancyName: [],
    name: [],
    position: [],
    introduction: [],
    isRegisterd: [],
    organizationUnitId: []
  };

  mounted() {
    this.getTenant(+this.$route.params["id"]);
  }

  async getTenant(id: number) {
    let tenant = await schoolService.get(id);
    this.tenant = <UpdateTenantDto>tenant;
  }

  async submitExecute(): Promise<void> {
    await schoolService.update(this.tenant);
  }
}
